export const dolores: string[] = [
  'Cotizas y te dicen "uy, qué caro", y terminas bajando el precio para no perder la clienta.',
  'Tu negocio entero vive en notas del celular, capturas de pantalla y mil chats de WhatsApp.',
  'Te acuestas con miedo de que se te haya pasado algo del evento del sábado.',
  'Los proveedores te tratan como "la chica de la deco" y hacen lo que quieren el día del montaje.',
  'Los papás te regatean como si les estuvieras vendiendo verdura. No tienen idea de todo lo que hay detrás.',
  'Tienes el talento y el ojo, pero no tienes un negocio: tienes eventos sueltos.',
  'Sientes que estás improvisando y que en cualquier momento se te va a notar.',
  'Trabajaste un mes entero para esa fiesta y cuando sacaste cuentas casi no ganaste nada.',
]
